module.exports = __webpack_public_path__ + "static/media/trash.0a312815.svg";